export const PRAYER_REQUEST_HASH = "prayer-request"
export const TESTIMONY_HASH = "testimony"

const modalHashes = new Set([PRAYER_REQUEST_HASH, TESTIMONY_HASH])

export function isPrayerTestimonyHash(hash: string): boolean {
  const id = decodeURIComponent(hash.replace(/^#/, ""))
  return modalHashes.has(id)
}
